import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column gap-60 w-100 ps-5 pt-4">
      <img
        src="assets/images/black_logo.png"
        alt="ico here"
        width={130}
        height={26}
      />
      <div className="d-flex flex-column justify-content-center align-items-center gap-3 pt-5">
        <h3 className="not-found-header">something went wrong</h3>
        <div className="d-flex flex-column gap-5 align-items-center justicy-content-start w-40">
          <p className="m-0 not-found-p1">
            We have encountered an error processing this request. Please refresh
            and try again.
          </p>
          <p className="m-0 not-found-p1">
            If you continue to have an error, contact the Greyled support team
            at <b className="text-decoration-underline">support@greyled.com</b>.
          </p>
        </div>
        <div className="d-flex w-40 pt-3">
          <button
            className="modal_footer_primary_btn bg-black text-white"
            type="button"
            onClick={() => navigate("/", { replace: true })}
          >
            Go to your Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
